<div class="dialog-content-wrapper preview-dialog" fxLayout="column" fxFlex="1 1 100%">
    <mat-toolbar matDialogTitle class="m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                Visualizar ordem de compra
            </span>

            <button (click)="matDialogRef.close()" mat-icon-button aria-label="Fechar" matTooltip="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div fxLayout="column" fxFlex="1 1 100%" style="padding-top: 2px;">
        <div *ngIf="loading" fxLayoutAlign="center center" style="height: 100%;">
            <mat-spinner color="primary" diameter="150"></mat-spinner>
        </div>

        <iframe src="about:blank" #contentIframe id="purchase-order-frame" width="100%" style="transition: opacity 500ms;"
            [ngStyle]="{'height':loading?'0px':'100%','opacity':loading?'0':'1'}" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture background-color: #fff;"
            allowfullscreen></iframe>
    </div>

    <!-- Botões do DS: Fechar ghost, Imprimir secondary, Gerar PDF primary -->
    <div mat-dialog-actions class="m-0 p-16 border-top preview-actions">
        <button type="button" (click)="matDialogRef.close()" class="oa-btn oa-btn--ghost">
            Fechar
        </button>

        <button type="button" (click)="print()" class="oa-btn oa-btn--secondary">
            <mat-icon>print</mat-icon>
            <span>Imprimir</span>
        </button>

        <button *ngIf="data?.tokenLink" type="button" (click)="openPDF()" class="oa-btn oa-btn--primary">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Gerar PDF</span>
        </button>
    </div>
</div>
